export default "__VITE_ASSET__R8SS17uL__"